import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { init as initAnalytics } from './lib/analytics';
import './styles.css';

// Initialise telemetry before render so the page-view event fires from boot.
// Falls back to no-op when VITE_APPINSIGHTS_CONNECTION_STRING is unset.
initAnalytics(import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING);

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root missing from index.html');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
